import {
    CategoryAnswer,
    CompletedQuestion,
    IAskQuestion, ICompletedCategoryQuestion,
    ICompletedMultipleChoiceQuestion,
    ICompletedOrderQuestion
} from "@/Core/Interactions";
import {ITutorialVariables} from "@/Core/TutorialVariables";

export interface TutorialAttemptApi {
    tutorialAttempt: TutorialAttemptDto;
    
    startOrContinueAttempt(): Promise<TutorialAttemptDto>;
    submitMultipleChoice(questionCode: string, answers: string[]): Promise<ICompletedMultipleChoiceQuestion>;
    submitOrderQuestion(questionCode: string, answerCodes: string[]): Promise<ICompletedOrderQuestion>;
    submitCategoriseQuestion(questionCode: string, answers: CategoryAnswer[]): Promise<ICompletedCategoryQuestion>;
    getQuestion(questionCode: string): IAskQuestion|null;
    getCompletedQuestion(questionCode: string): CompletedQuestion|null;
    getCompletedQuestions(): CompletedQuestion[];
    endTutorialAttempt(): Promise<ICompletedAttemptResult>;
    submitTutorialApproval(isApproved: boolean, approvalNotes: string): Promise<void>;
    canExit(): boolean;
    exit(): void;
}

enum RequestError {
    Unknown = 0,
    CheckInternet = 1,
    ServiceDown = 2,
    AuthorizationError = 3,
    TransientError = 4,
    AuthenticationError = 5
}

export class TutorialAttemptDto {
    completed: boolean;
    isApproval: boolean;
    questions: IAskQuestion[];
    variables: ITutorialVariables;
}

export interface ICompletedAttemptResult {
    completed: boolean;
    passInformation: {
        passed: boolean;
        markPercent: number;
        passPercent: number;
    }|null;
}